import { routersTypes } from 'src/pages/routes';
/*
 * @description： 第三方对接相关页面
 */
const basePrefix = '/hospital/third/';

const route: routersTypes[] = [
  {
    path: `${basePrefix}pay-carrier-result`,
    name: 'PayCarrierResult',
    component: () => import(/* webpackPrefetchPlaceHolder */ './payCarrierResult'),
    auth: false,
    exact: true,
    title: '众安互联网医院',
  },
];
export default route;
